import React from "react";

import * as styles from "./styles";

export function Address({ address }: { address?: string }) {
  if (!address) {
    return null;
  }

  return <p className={styles.container}>{address}</p>;
}
